<template>
  <!--表单-->
  <section class="home-form">
    <div class="container">
      <div class="form-box">
        <el-form label-position="left" label-width="90px" :model="formData">
          <el-form-item label="房屋面积">
            <el-input v-model="formData.positionName"
                      placeholder="请输入面积（m²）"></el-input>
          </el-form-item>

          <el-form-item label="项目地址"
                        prop="companyName" >
            <el-input v-model="formData.companyName"
                      placeholder="请输入详细地址"></el-input>
          </el-form-item>

          <el-form-item label="姓名"
                        prop="name">
            <el-input v-model="formData.name" maxlength="10"
                      placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="联系电话"
                        prop="contactWay">
            <el-input v-model="formData.contactWay" maxlength="11"
                      placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="留言内容"
                        prop="requestDesc">
            <el-input v-model="formData.requestDesc" maxlength="140"
                      placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>

        <div class='form-btn' @click='saveContact'>
          发送 >
        </div>
      </div>

    </div>
  </section>
</template>

<script>
  import {getNavList, contactCreate} from "@/api/index/index";

  export default {
    data() {
      return {
        navList: [],
        formData: {
          name: '',
          companyName: '',
          positionName: '',
          contactWay: '',
          requestDesc: ''
        },
      };
    },
    methods: {
      async getNavList() {
        var res = await getNavList({
          navigationParent: this.$route.query.primaryKey,
        });
        this.navList = res.data;
        this.setNavInfo(this.navList[0]);
      },

      async saveContact() {
        if (!this.formData.name || !this.formData.name.trim()) {
          this.$message.error('请输入您的姓名。')
          return
        }
        if (!this.formData.contactWay || !this.formData.contactWay.trim()) {
          this.$message.error('请输入联系方式。')
          return
        }
        // 防止频繁保存
        if (this.ISPOST) {
          this.$message({
            message: '操作太频繁！',
            type: 'warning'
          })
          return
        }

        this.ISPOST = true

        setTimeout(() => {
          this.ISPOST = false
        }, 3000)
        console.log(this.formData, contactCreate)
        var res = await contactCreate(this.formData)

        this.$message({
          message: '发送成功，稍后我们的工作人员会与您联系！',
          type: 'success'
        })
        this.formData = {
          name: '',
          companyName: '',
          positionName: '',
          contactWay: '',
          requestDesc: ''
        }
      }
    },


    mounted() {
    },
  };
</script>
<style lang="scss">
  .home-form {
    padding: 20px 0 40px;
    /*border-bottom: 1px solid #e0e0e0;*/

    .container{
      /*min-height: 240px;*/
      display: flex;
      align-items: center;
    }

    .el-form{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .el-form-item {
      width: 45%;
      border-bottom: 2px solid #e0e0e0;
      margin-bottom: 12px;

      .el-input__inner {
        border: none !important;
      }

      .el-select {
        width: 100%;
      }

      .el-form-item__label {
        font-size: 18px;
      }

      .el-input__inner {
        font-size: 18px;

      }
    }

    .el-form-item:last-child{
      width: 100%;
    }

    .form-btn {
      width: 122px;
      height: 45px;
      background: #B1CECC;
      font-size: 18px;
      line-height: 45px;
      text-align: center;
      color: #fff;
      margin-top: 15px;
    }
  }

  @media screen and (max-width: 768px) {
    .home-form{
      padding: 60px 0 0;

      .container{
        display: block;
        height: inherit;
      }

      .el-form{
        display: block;
      }

      .el-form-item{
        width: 100%;
        margin-bottom: 22px;
      }

      .form-btn{
        margin-top: 25px;
      }
    }


  }
</style>
